import {forwardRef} from "react";
import {useTranslation} from "react-i18next";
import {Text, TextProps} from "@mantine/core";

export const NotApplicableText = forwardRef<HTMLDivElement, TextProps>((props, ref) => {
  const {t} = useTranslation(["common"])

  return (
    <Text ref={ref} {...props}>
      {t("common.notapplicable.short", "N/A")}
    </Text>
  )
})
